import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";
const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchSaveNbcuSettingsData = createAsyncThunk(
  "saveSaveNbcuSettingsData/fetchSaveNbcuSettingsData",
  async ({ data, id }) => {
 
    const response = await axiosInstance.request({
      url: `/settings/nbcuweighting/${id}`,
      method: `PATCH`,
      data: { ...data },
    });
    return response;
  }
);

const saveSaveNbcuSettingsDataSlice = createSlice({
  name: "saveSaveNbcuSettingsData",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchSaveNbcuSettingsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSaveNbcuSettingsData.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchSaveNbcuSettingsData.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const SaveNbcuSettingsDataReducer = saveSaveNbcuSettingsDataSlice.reducer;

export default SaveNbcuSettingsDataReducer;

export const saveSaveNbcuSettingsDataAction =
  saveSaveNbcuSettingsDataSlice.actions;
